import { render, staticRenderFns } from "./AnswerInfo.vue?vue&type=template&id=b30deeb8&scoped=true&"
import script from "./AnswerInfo.vue?vue&type=script&lang=js&"
export * from "./AnswerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30deeb8",
  null
  
)

export default component.exports